import { HiCalendar, HiChartBar, HiStar, HiTrendingUp } from "react-icons/hi";
import type { StreakAnalysisQuery } from "../../../generated/graphql";

interface StreakDisplayProps {
  data: StreakAnalysisQuery["streakAnalysis"] | null | undefined;
}

export function StreakDisplay({ data }: StreakDisplayProps) {
  if (!data) {
    return (
      <div className="flex items-center justify-center h-48">
        <div className="text-gray-600">No streak data available</div>
      </div>
    );
  }

  const stats = [
    {
      label: "Current Streak",
      value: data.currentStreak,
      unit: "days",
      icon: HiTrendingUp,
      accentClass: "border-l-warning-500",
    },
    {
      label: "Longest Streak",
      value: data.longestStreak,
      unit: "days",
      icon: HiStar,
      accentClass: "border-l-accent-500",
    },
    {
      label: "Total Study Days",
      value: data.totalStudyDays,
      unit: "days",
      icon: HiCalendar,
      accentClass: "border-l-primary-500",
    },
    {
      label: "Avg Slides/Day",
      value: data.averageSlidesPerDay.toFixed(1),
      unit: "slides",
      icon: HiChartBar,
      accentClass: "border-l-success-500",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div key={stat.label} className={`panel p-6 border-l-4 ${stat.accentClass}`}>
            <div className="flex items-center justify-between mb-2">
              <Icon className="text-2xl text-secondary-400" />
              <span className="text-3xl font-bold text-secondary-200">{stat.value}</span>
            </div>
            <div className="label">{stat.label}</div>
            <div className="caption">{stat.unit}</div>
          </div>
        );
      })}
    </div>
  );
}
